/*!
FullCalendar Resource Time Grid Plugin v6.1.15
Docs & License: https://fullcalendar.io/docs/vertical-resource-view
(c) 2024 Adam Shaw
*/ FullCalendar.ResourceTimeGrid = function(e, t, l, o, r, s, i, a, n, d) {
    "use strict";
    function u(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    var c = u(l), h = u(o), m = u(r);
    class p extends n.VResourceJoiner {
        transformSeg(e, t, l) {
            return [
                Object.assign(Object.assign({}, e), {
                    col: t.computeCol(e.col, l)
                })
            ];
        }
    }
    class R extends s.DateComponent {
        constructor(){
            super(...arguments), this.buildDayRanges = s.memoize(a.buildDayRanges), this.splitter = new n.VResourceSplitter, this.slicers = {}, this.joiner = new p, this.timeColsRef = i.createRef(), this.isHitComboAllowed = (e, t)=>1 === this.dayRanges.length || e.dateSpan.resourceId === t.dateSpan.resourceId;
        }
        render() {
            let { props: e, context: t } = this, { dateEnv: l, options: o } = t, { dateProfile: r, resourceDayTableModel: n } = e, d = this.dayRanges = this.buildDayRanges(n.dayTableModel, r, l), u = this.splitter.splitProps(e);
            this.slicers = s.mapHash(u, (e, t)=>this.slicers[t] || new a.DayTimeColsSlicer);
            let c = s.mapHash(this.slicers, (e, l)=>e.sliceProps(u[l], r, null, t, d));
            return i.createElement(s.NowTimer, {
                unit: o.nowIndicator ? "minute" : "day"
            }, (t, l)=>i.createElement(a.TimeCols, Object.assign({
                    ref: this.timeColsRef
                }, this.joiner.joinProps(c, n), {
                    dateProfile: r,
                    axis: e.axis,
                    slotDuration: e.slotDuration,
                    slatMetas: e.slatMetas,
                    cells: n.cells[0],
                    tableColGroupNode: e.tableColGroupNode,
                    tableMinWidth: e.tableMinWidth,
                    clientWidth: e.clientWidth,
                    clientHeight: e.clientHeight,
                    expandRows: e.expandRows,
                    nowDate: t,
                    nowIndicatorSegs: o.nowIndicator && this.buildNowIndicatorSegs(t),
                    todayRange: l,
                    onScrollTopRequest: e.onScrollTopRequest,
                    forPrint: e.forPrint,
                    onSlatCoords: e.onSlatCoords,
                    isHitComboAllowed: this.isHitComboAllowed
                })));
        }
        buildNowIndicatorSegs(e) {
            let t = this.slicers[""].sliceNowDate(e, this.props.dateProfile, this.context.options.nextDayThreshold, this.context, this.dayRanges);
            return this.joiner.expandSegs(this.props.resourceDayTableModel, t);
        }
    }
    class b extends a.TimeColsView {
        constructor(){
            super(...arguments), this.flattenResources = s.memoize(n.flattenResources), this.buildResourceTimeColsModel = s.memoize(y), this.buildSlatMetas = s.memoize(a.buildSlatMetas);
        }
        render() {
            let { props: e, context: t } = this, { options: l, dateEnv: o } = t, { dateProfile: r } = e, s = this.allDaySplitter.splitProps(e), a = l.resourceOrder || n.DEFAULT_RESOURCE_ORDER, u = this.flattenResources(e.resourceStore, a), c = this.buildResourceTimeColsModel(r, t.dateProfileGenerator, u, l.datesAboveResources, t), h = this.buildSlatMetas(r.slotMinTime, r.slotMaxTime, l.slotLabelInterval, l.slotDuration, o), { dayMinWidth: m } = l, p = !m, b = m, y = l.dayHeaders && i.createElement(n.ResourceDayHeader, {
                resources: u,
                dates: c.dayTableModel.headerDates,
                dateProfile: r,
                datesRepDistinctDays: !0,
                renderIntro: p ? this.renderHeadAxis : null
            }), D = !1 !== l.allDaySlot && ((t)=>i.createElement(d.ResourceDayTable, Object.assign({}, s.allDay, {
                    dateProfile: r,
                    resourceDayTableModel: c,
                    nextDayThreshold: l.nextDayThreshold,
                    tableMinWidth: t.tableMinWidth,
                    colGroupNode: t.tableColGroupNode,
                    renderRowIntro: p ? this.renderTableRowAxis : null,
                    showWeekNumbers: !1,
                    expandRows: !1,
                    headerAlignElRef: this.headerElRef,
                    clientWidth: t.clientWidth,
                    clientHeight: t.clientHeight,
                    forPrint: e.forPrint
                }, this.getAllDayMaxEventProps()))), C = (t)=>i.createElement(R, Object.assign({}, s.timed, {
                    dateProfile: r,
                    axis: p,
                    slotDuration: l.slotDuration,
                    slatMetas: h,
                    resourceDayTableModel: c,
                    tableColGroupNode: t.tableColGroupNode,
                    tableMinWidth: t.tableMinWidth,
                    clientWidth: t.clientWidth,
                    clientHeight: t.clientHeight,
                    onSlatCoords: this.handleSlatCoords,
                    expandRows: t.expandRows,
                    forPrint: e.forPrint,
                    onScrollTopRequest: this.handleScrollTopRequest
                }));
            return b ? this.renderHScrollLayout(y, D, C, c.colCnt, m, h, this.state.slatCoords) : this.renderSimpleLayout(y, D, C);
        }
    }
    function y(e, t, l, o, r) {
        let s = a.buildTimeColsModel(e, t);
        return o ? new n.DayResourceTableModel(s, l, r) : new n.ResourceDayTableModel(s, l, r);
    }
    var D = t.createPlugin({
        name: "@fullcalendar/resource-timegrid",
        premiumReleaseDate: "2024-07-12",
        deps: [
            c.default,
            h.default,
            m.default
        ],
        initialView: "resourceTimeGridDay",
        views: {
            resourceTimeGrid: {
                type: "timeGrid",
                component: b,
                needsResourceData: !0
            },
            resourceTimeGridDay: {
                type: "resourceTimeGrid",
                duration: {
                    days: 1
                }
            },
            resourceTimeGridWeek: {
                type: "resourceTimeGrid",
                duration: {
                    weeks: 1
                }
            }
        }
    }), C = {
        __proto__: null,
        ResourceDayTimeColsView: b,
        ResourceDayTimeCols: R
    };
    return t.globalPlugins.push(D), e.Internal = C, e.default = D, Object.defineProperty(e, "__esModule", {
        value: !0
    }), e;
}({}, FullCalendar, FullCalendar.PremiumCommon, FullCalendar.Resource, FullCalendar.TimeGrid, FullCalendar.Internal, FullCalendar.Preact, FullCalendar.TimeGrid.Internal, FullCalendar.Resource.Internal, FullCalendar.ResourceDayGrid.Internal);

//# sourceMappingURL=index.eebd23f1.js.map
